const PanelFooter = ({ children, className = '', style = {} }) => {
  return (
    <div className={`comp-panel-footer ${className}`} style={style}>
      {children}
    </div>
  );
};

export default PanelFooter;
